import React from "react";
import { Chip } from "@mui/joy";
import { ClassStatus } from "../types/Class";

export const getStatusColor = (status: ClassStatus) => {
  switch (status) {
    case ClassStatus.Current:
      return "success";
    case ClassStatus.Future:
      return "primary";
    case ClassStatus.Past:
      return "neutral";
    default:
      return "neutral";
  }
};

export const StatusBadge: React.FC<{ status: ClassStatus }> = ({ status }) => {
  return (
    <Chip
      size="sm"
      variant="soft"
      color={getStatusColor(status)}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Chip>
  );
}; 